<bl-modal-content #content
  [title]="_title"
  [footerButtonType]="_footerButtonType"
  [okButtonSetting]="_okButtonSetting"
  [cancelButtonSetting]="_cancelButtonSetting"
>
  <div class="confirm-contents" body>
    <div><span class="confirm-name-text">株式会社ブロードリーフ</span>が提供するデータの利用範囲は、データ入手元から使用を認められている範囲に制限され、貴社内における経営分析等、通常業務の範囲内に制限されます。</div>
    <div>したがって、第三者へのデータ提供等は<span class="confirm-bold-text">「契約違反」</span>に該当します。</div>
    <div>また、データ出力の状況は記録され、関連するデータ入手元等へ報告されます。</div>
    <br>
    <div>以下の制約事項を遵守することに同意しますか。</div>
    <br>
    <div class="confirm-row">
      <span class="confirm-bold-text">1.&nbsp;</span>
      <span class="confirm-bold-text">貴社内における通常業務の範囲を超えて利用しないものとします。</span>
    </div>
    <div class="confirm-row">
      <span class="confirm-bold-text">2.&nbsp;</span>
      <span class="confirm-bold-text">第三者に開示しないのはもちろんのこと、目的を果たすために必要最低限の役員及び従業員以外には開示しないものとします。</span>
    </div>
    <div class="confirm-row">
      <span class="confirm-bold-text">3.&nbsp;</span>
      <span class="confirm-bold-text">複製、変更、解析などの行為をしないものとします。</span>
    </div>
    <div class="confirm-row">
      <span class="confirm-bold-text">4.&nbsp;</span>
      <span class="confirm-bold-text">「秘密情報」に関して行った行為については、全ての責任を負うものとします。</span>
    </div>
    <div class="confirm-row">
      <span class="confirm-bold-text">5.&nbsp;</span>
      <span class="confirm-bold-text">これらの契約に違反したことにより損害が生じた場合、その一切の損害を賠償するものとします。</span>
    </div>
    <div>※詳細については、締結致しました<span class="confirm-highlight-text">「秘密保持等確認書」</span>をご確認ください。</div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/export-request-confirm/export-request-confirm.component.html